import React, { useState, useEffect, useCallback } from "react";
import moment from 'moment';


import { Grid, Typography, MenuItem, Select, Autocomplete, TextField, InputLabel } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

import {
  DataGrid,
  GridEditCellProps
} from '@mui/x-data-grid';
import CMAutocomplete from '../../components/molecules/CMAutocomplete';

import { Icon } from '@mui/material';
import { PictureAsPdf } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { useParams, useHistory } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

//Components
import CMLabel from '../../components/atoms/CMLabel';
import CMDatePicker from '../../components/molecules/CMDatePicker';
import CMButton from '../../components/atoms/CMButton';
import CMIconButton from '../../components/atoms/CMIconButton';
import DeleteIcon from '@mui/icons-material/Delete';

//Constants
import { MomentLocaleEs } from '../../constants/MomentLocaleEs';
//Services
import * as OrdenesService from '../../services/OrdenesService';
import * as ProveedorService from '../../services/ProveedorService';
import * as ProyectoService from '../../services/ProyectoService';


import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import CMTextField from "../../components/atoms/CMTextField";
import { v4 as uuidv4 } from 'uuid';
import Checkbox from '@mui/material/Checkbox';

const MySwal = withReactContent(Swal)


const CrearordenPeriodoEditarBorrador = () => {
  const [rowsdata, setRowsdata] = useState([]);
  const [rowsgrid, setRowsgrid] = useState([]);
  const [comment, setComment] = useState('');
  //Nuevo
  const [proveedor, setProveedor] = useState([]);
  const [ruc, setRuc] = useState('');
  const [idprovedor, setIdprovedor] = useState([]);
  const [nombreProveedor, setNombreProvedor] = useState([]);
  const [codigoProveedorsap, setCodigoProveedorsap] = useState([]);
  const [contacto, setContacto] = useState([]);
  const [selectPersonaContacto, setSelectPersonaContacto] = useState(null);
  const [fechacontable, setFechacontable] = useState(moment().locale('es', MomentLocaleEs));
  const [fechaentrega, setFechaentrega] = useState(moment().locale('es', MomentLocaleEs));
  const [fechainicio, setFechainicio] = useState(moment().locale('es', MomentLocaleEs));
  const [fechafin, setFechafin] = useState(moment().locale('es', MomentLocaleEs));

  const [fecharegistro, setFecharegistro] = useState([]);
  const [motivotraslado, setMotivotraslado] = useState('');
  const [selectProveedor, setSelectProveedor] = useState(null);
  const [tipocambio, setTipocambio] = useState('S/');
  const [idcontacto,setIdcontacto] = useState([]);
  const [condiciondepago, setCondicionDepago] = useState([]);
  const [destino, setDestino] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [selectedConditionPago, setSelectedConditionPago] = useState(null); // Estado para almacenar la condición seleccionada
  const [selectedDestino, setSelectedDestino] = useState(null); // Estado para almacenar la condición seleccionada
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cecos, setCecos] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [cuentaContable, setCuentaContable] = useState([]);
  const [editedCecos, setEditedCecos] = useState([]);
  const [editedAlmacenes,setEditedAlmacenes] = useState([]);
  const [editedCuentaContable, setEditedCuentaContable] = useState([]); // Inicializar con un arreglo vacío
  const [cargando, setCargando] = React.useState(false);
  const [serieDocumento, setSerieDocumento] = useState('');
  const [correlativoDocumento, setCorrelativoDocumento] = useState('');

  const [tipoDocumento, setTipoDocumento] = useState('00')

  const [optionDestino, setOptionDestino] =useState([]);

  const [records, setRecords] = useState([]);
  const [products, setProducts] = useState(null);
  const [valueProduct, setValueProduct] = useState('');
  const [selectionProduct, setSelectionProduct] = useState(null);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loadingGrid, setLoadingGrid] =  useState(false);
  const loading = open && options.length === 0;
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [nextId, setNextId] = useState(1); // Variable para generar claves únicas
  const user = JSON.parse(window.localStorage.getItem("user"));
  const [registrarbtn, setRegistrarbtn] = useState(false);
  const [correo, setCorreo] = useState('');
  const [fechahoy,setFechahoy] =useState(moment().locale('es', MomentLocaleEs));
  const [proyectos,setProyectos] = useState('');
  const [etapas,setEtapas] = useState('');
  const [periodo,setPeriodo] = useState('ninguno');

  const [editedProyectos, setEditedProyectos] = useState([]);

  useEffect(() => {
    OrdenesService.getOCIDPERIODOBORRADOR(setRowsdata,ordenid,user.token);
    OrdenesService.getListProveedores(setProveedor, user.token);
    OrdenesService.getListPersonaContacto(setContacto, user.token);
   OrdenesService.getListDestino(setDestino, user.token);
    OrdenesService.getListProducts(setProducts, user.token);
    OrdenesService.getListCecos(setCecos, user.token);
    OrdenesService.getListAlmacen(setAlmacenes, user.token);
    OrdenesService.getListCuentaContable(setCuentaContable, user.token);
    ProyectoService.getProjects(setProyectos,user.token);
  }, []);
  useEffect(() => {
    let active = true;

    if (!loading)
      return undefined;

    (async () => {
      if (active)
        setOptions([...products]);
    })();

    return () => { active = false; };
  }, [loading]);

  useEffect(() => {
    if (!open)
      setOptions([]);
  }, [open])


  const message = (text, type) => {
    setNotify({
      isOpen: true,
      message: text,
      type: type
    })
  }

  // const handleAddProduct = () => {
  //   if (selectedProduct && !isProductAlreadyAdded(selectedProduct)) {
  //     const newProduct = {
  //       ...selectedProduct,
  //       id: nextId, // Asignar una clave única al producto
  //       precio_unitario: 0, // Valor inicial para el campo editable "Precio Unitario"
  //       cantidad_pedida: 0, // Valor inicial para el campo editable "Cantidad pedida"
  //       total_articulo:0, // Valor inicial para el campo editable "Total
  //       fecha_entrega: null, // Valor inicial para el campo editable "Fecha Entrega"
  //       codigo_ceco: null,
  //       codigo_departamento: null,
  //       codigo_seccion:null,
  //       codigo_almacen_sap:null
  //     };
  //     setSelectedProducts([...selectedProducts, newProduct]);
  //     setSelectedProduct(null);
  //     setNextId(nextId + 1); // Incrementar el valor de la próxima clave única
  //   }
  // };
 
  const isProductAlreadyAdded = (product) => {
    return selectedProducts.some((p) => p.codigo_producto_sap === product.codigo_producto_sap);
  };

  //Fin nuevo

  const useFakeMutation = () => {
    return React.useCallback(
      (user) =>
        new Promise((resolve, reject) =>
          setTimeout(() => {
            if (user.name?.trim() === '') {
              reject(new Error("Error al guardar el usuario: el nombre no puede estar vacÃ­o"));
            } else {
              resolve({ ...user, name: user.name?.toUpperCase() });
            }
          }, 200),
        ),
      [],
    );
  };
  const mutateRow = useFakeMutation();
  const [snackbar, setSnackbar] = useState(null);
  const [dataresponse, setDataresponse] = useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);
  const handleProcessRowUpdateError = React.useCallback((error) => {
    setSnackbar({ children: error.message, severity: 'error' });
  }, []);

  const { ordenid } = useParams();

  let idCounter = 0; // Inicializamos el contador

  useEffect(() => {
    // console.log('Rowsdata:', rowsdata);
    if (rowsdata && Object.keys(rowsdata).length > 0) {
      console.log('Rowsdata:', rowsdata);
      setPeriodo(rowsdata.periodo);
      setFechainicio(rowsdata.finicio_periodico);
      setFechafin(rowsdata.ffin_periodico);   
      setRowsgrid(rowsdata.oc_detalles);
    }
  }, [rowsdata]);


  const formatCurrency = (value) => {
    return value.toLocaleString('es-PE', {
      style: 'currency',
      currency: 'PEN',
    });
  };



  const formatNumberWithDot = (number) => {
    return number.toString().replace(',', '.');
  };

  const parseNumberWithDot = (value) => {
    return value.replace('.', ',');
  };

  
  const handleCellValueChange = async (params, newValue,codigo_ceco) => {
    const { id } = params;
    const editedCecoIndex = editedCecos.findIndex((ceco) => ceco.id === id);
  
    if (editedCecoIndex !== -1) {
      // Si el ceco ya ha sido editado previamente, actualiza su valor
      const updatedCecos = [...editedCecos];
      updatedCecos[editedCecoIndex] = { id, nombre_ceco: newValue, codigo_ceco};
      setEditedCecos(updatedCecos);
    } else {
      // Si es un ceco nuevo, añádelo al estado de editedCecos
      setEditedCecos((prevCecos) => [...prevCecos, { id, nombre_ceco: newValue, codigo_ceco }]);
    }
  
    try {
      // Obtener los valores de codigo_departamente, codigo_seccion y codigo_ceco del API getCecosId
      const response = await OrdenesService.getCecosId(codigo_ceco, user.token);
      if (response) {
        const { codigo_departamente, codigo_seccion } = response;
  
        // Actualizar los campos relacionados en la fila actual
        const updatedRecords = records.map((record) => {
          if (record.id === id) {
            return { ...record, nombre_ceco: newValue, codigo_departamente, codigo_seccion, codigo_ceco };
          }
          return record;
        });
        setRecords(updatedRecords);
      } else {
        console.error('La respuesta del API getCecosId no es válida:', response);
      }
    } catch (error) {
      // Manejar el error aquí
      console.error('Error al obtener los valores de codigo_departamente y codigo_seccion:', error);
    }
  };
  const handleCellValueChangeCuentaContable = (params, newValue,nombre_cuenta_contable, codigo_cuenta_contable) => {
    const { id } = params;
    const editedCuentaIndex = editedCuentaContable.findIndex((cuenta) => cuenta.id === id);
  
    if (editedCuentaIndex !== -1) {
      // Si la cuenta contable ya ha sido editada previamente, actualiza su valor
      const updatedCuentas = [...editedCuentaContable];
      updatedCuentas[editedCuentaIndex] = { id, nombre_cuenta: newValue,nombre_cuenta_contable, codigo_cuenta_contable };
      setEditedCuentaContable(updatedCuentas);
    } else {
      // Si es una cuenta contable nueva, añádela al estado de editedCuentaContable
      setEditedCuentaContable((prevCuentas) => [...prevCuentas, { id, nombre_cuenta: newValue, nombre_cuenta_contable,codigo_cuenta_contable }]);
    }
  
    // Actualizar los campos relacionados en la fila actual
    const updatedRecords = records.map((record) => {
      if (record.id === id) {
        return { ...record, nombre_cuenta: newValue,nombre_cuenta_contable, codigo_cuenta_contable };
      }
      return record;
    });
    setRecords(updatedRecords);
  };

  const handleCellValueChangeProyecto = async (params, newValue) => {
    const name = newValue ? newValue.split(' -- ')[0] : '';
    const docnum = newValue ? newValue.split(' -- ')[1] : '';
  
    // Actualizar estado de proyectos editados
    setEditedProyectos((prev) => {
      const updatedList = prev.some((p) => p.absEntry === params.id)
        ? prev.map((p) => (p.absEntry === params.id ? { ...p, name, docnum } : p))
        : [...prev, { absEntry: params.id, name, docnum }];
      
      return updatedList;
    });
  
    try {
      // Buscar el proyecto seleccionado
      const selectedProyecto = proyectos.find((p) => p.name === name);
      if (selectedProyecto) {
        // console.log(selectedProyecto);
        const { fiProject, absEntry } = selectedProyecto;
  
        // Actualizar el estado de records
        setRecords((prevRecords) =>
          prevRecords.map((record) =>
            record.id === params.id
              ? {
                  ...record,
                  fiProject,
                  AbsEntryProyecto: absEntry, // Guardamos AbsEntryProyecto correctamente
                  DocNumProyecto:selectedProyecto.docnum,
                  NombreProyecto: name,
                  stageId: null, // Resetear la etapa
                  etapa: '',
                }
              : record
          )
        );
  
        // Obtener las etapas del nuevo proyecto
        ProyectoService.getStagesByProject(absEntry, user.token, setEtapas);
      } else {
        console.error('Proyecto no encontrado:', name);
      }
    } catch (error) {
      console.error('Error al obtener el fiProject:', error);
    }
  };
  
  const handleProductChange = (value) => {
    if(options.includes(value)){
      setSelectionProduct(value);
    }
    else{
      setSelectionProduct(null);
    }
  };
  const handleSelectChange = (params, selectedValue) => {
    let newValue;
    if (selectedValue === 'IGV_RES') {
      newValue = 0.10; // Sin IGV
    } else if (selectedValue === 'IGV') {
      newValue = 0.18; // IGV 18%
    } else if (selectedValue === 'EXE_IGV') {
      newValue = 0; // Sin IGV
    }
  else if (selectedValue === '') {
    newValue = ""; // Sin IGV
  }
    else {
      // Manejar cualquier otro caso o error
      newValue = null;
    }
    // Llama a la función que maneja el cambio del valor de la celda
    // Pasa el nuevo valor y los parámetros necesarios
    handleCheckboxChange(params, newValue);
  };
  const agregarServicio = () => {
    // Crear el nuevo objeto de la fila a agregar
    const nuevaFila = {
      id: uuidv4(),
      descripcion:'',
      Valor_unitario: '',
      igv:'',
      precio_unitario: '',
      fecha_entrega: '',
      nombre_ceco: '',
      codigo_departamente:'',
      codigo_seccion:'',
      nombre_cuenta:'',
      nombre_cuenta_contable:'',
      codigo_cuenta_contable:'',
      incluyeIgv:'',
      proyecto:'',
      etapas:'',
      fiProject:'',
      AbsEntryProyecto:'',
      NombreProyecto:'',
      DocNumProyecto:'',
      FiProject:'',
      StageIdEtapa:'',
      NombreEtapa:''
    };
  
    // Agregar la nueva fila al array de records
    const nuevosRecords = [...records, nuevaFila];
  
    // Actualizar el estado de records con la nueva fila agregada
    setRecords(nuevosRecords);
  };
  const [includeIgv, setIncludeIgv] = useState(false);

  const handleCheckboxChange = (params, checked) => {
    // Actualizar el valor de incluyeIgv en los datos de esa fila
    const updatedRow = {...params.row, incluyeIgv: checked};
    
    setRecords(rows => 
      rows.map(row => 
        row.id === params.id ? updatedRow : row  
      )
    );
  }

  const handleStageChange = (params, newValue) => {
    const selectedStage = etapas.find((stage) => stage.name === newValue);
    const stageId = selectedStage ? selectedStage.stageId : null;
  
    setRecords((prevRecords) =>
      prevRecords.map((record) =>
        record.id === params.id ? { ...record, stageId,StageIdEtapa:stageId, etapa: newValue,NombreEtapa:newValue } : record
      )
    );
  };
   const columns2 = [
        { field: 'descripcion', headerName: 'Descripción', width: 650, align: 'center',headerAlign: 'center' },
        // { field: 'fecha_entrega', headerName: 'Fecha Entrega', width: 180, align: 'center',headerAlign: 'center',
        // valueFormatter: (params) => params.value ? moment(params.value).format('DD/MM/YYYY') :'00/00/0000'},
      { field: 'codigo_ceco', headerName: 'Codigo Ceco', width: 120, align: 'center',headerAlign: 'center'},
      { field: 'codigo_departamente', headerName: 'Codigo departamento', width: 160, align: 'center',headerAlign: 'center'},
      { field: 'codigo_seccion', headerName: 'Codigo sección', width: 120, align: 'center',headerAlign: 'center'},
        { field: 'nombre_cuenta_mayor', headerName: 'Nombre Cuenta Mayor', width: 300, align: 'center',headerAlign: 'center'},
        { field: 'nombreProyecto', headerName: 'Proyecto', width: 180, align: 'center',headerAlign: 'center' },
        { field: 'fiProject', headerName: 'FiProject', width: 180, align: 'center',headerAlign: 'center' },
        { field: 'nombreEtapa', headerName: 'Etapa', width: 180, align: 'center',headerAlign: 'center' },

        {
          field: 'tipo_igv',
          headerName: 'Tipo IGV',
          width: 180,
          align: 'center',
          headerAlign: 'center',
          valueGetter: (params) => {
            const valorSinIGV = params.row.include_igv==='EXONERADO' ?
             'EXONERADO' :
             params.row.include_igv==='IGV' ? 'IGV 18%': 'IGV 10%';
            return valorSinIGV;
          },
        },
          {
          field: 'valor_sin_igv',
          headerName: 'Precio sin IGV',
          width: 180,
          align: 'center',
          headerAlign: 'center',
          valueFormatter: (params) => formatCurrency(params.value, rowsdata.moneda),
          valueGetter: (params) => {
            const totalServicio = params.row.total_servicio;
            const valorSinIGV = params.row.include_igv==='EXONERADO' ?
             totalServicio :
             params.row.include_igv==='IGV' ? totalServicio / (1.18): totalServicio / (1.10);
            return valorSinIGV;
          },
        },
        {
          field: 'igv',
          headerName: 'IGV',
          width: 180,
          align: 'center',
          headerAlign: 'center',
          valueFormatter: (params) => formatCurrency(params.value, rowsdata.moneda),
          valueGetter: (params) => {
            const totalServicio = params.row.total_servicio;
            const valorSinIGV = params.row.include_igv==='EXONERADO' ?  0 :
            params.row.include_igv==='IGV' ? totalServicio - totalServicio / (1.18) : totalServicio - totalServicio / (1.10);
            return valorSinIGV;
          },
        },
        { field: 'total_servicio', headerName: 'Precio', width: 180, align: 'center',headerAlign: 'center',valueFormatter: (params) => formatCurrency(params.value,rowsdata.moneda) },

      ]
   const columns = [
         { field: 'codigo_articulo', headerName: 'Codigo Árticulo', width: 120, align: 'center',headerAlign: 'center' },
         { field: 'nombre_articulo', headerName: 'Árticulo', width: 480,headerAlign: 'center' },
         { field: 'unidad_medida', headerName: 'Unidad Medida', width: 180, align: 'center',headerAlign: 'center' },
         { field: 'cantidad_pedida', headerName: 'Cantidad Pedida', width: 150, align: 'center',headerAlign: 'center' },
         { field: 'cantidad_entregada', headerName: 'Cantidad Entregada', type:'number', width: 150, align: 'center',headerAlign: 'center',editable: true},
         { field: 'cantidad_recibida', headerName: 'Cantidad Recibida', width: 150, align: 'center',headerAlign: 'center' },
         // { 
         //     field: 'fecha_entrega', 
         //     headerName: 'Fecha Acuerdo', 
         //     type:'date',
         //     width: 140, 
         //     align: 'center',
         //     headerAlign: 'center',
         //     valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY') 
         //   },
           // { 
           //   field: 'fecha_recepcion', 
           //   headerName: 'Fecha Entrega', 
           //   type: 'date',
           //   width: 140, 
           //   align: 'center',
           //   headerAlign: 'center',
           //   valueFormatter: (params) => params.value ? moment(params.value).format('DD/MM/YYYY') :'00/00/0000',
           //   editable: true
           // },
           { 
             field: 'fecha_termino', 
             headerName: 'Fecha Recibida', 
             type: 'date',
             width: 140, 
             align: 'center',
             headerAlign: 'center',
             valueFormatter: (params) => params.value ? moment(params.value).format('DD/MM/YYYY') :'00/00/0000'
           },
           {
             field: 'tipo_igv',
             headerName: 'Tipo IGV',
             width: 180,
             align: 'center',
             headerAlign: 'center',
             valueGetter: (params) => {
               const valorSinIGV = params.row.include_igv==='EXONERADO' ?
                'EXONERADO' :
                params.row.include_igv==='IGV' ? 'IGV 18%': 'IGV 10%';
               return valorSinIGV;
             },
           },
           {
             field: 'valor_sin_igv',
             headerName: 'Precio sin IGV',
             width: 180,
             align: 'center',
             headerAlign: 'center',
             valueFormatter: (params) => formatCurrency(params.value, rowsdata.moneda),
             valueGetter: (params) => {
               const totalServicio = params.row.precio_unitario;
               const valorSinIGV = params.row.include_igv==='EXONERADO' ? totalServicio :
               params.row.include_igv==='IGV' ? totalServicio / (1.18) : totalServicio / (1.10);
               return valorSinIGV;
             },
           },
           { field: 'precio_unitario', headerName: 'Precio Unitario', width: 150, align: 'center',headerAlign: 'center',valueFormatter: (params) => formatCurrency(params.value,rowsdata.moneda) },
           {
             field: 'igv',
             headerName: 'IGV',
             width: 180,
             align: 'center',
             headerAlign: 'center',
             valueFormatter: (params) => formatCurrency(params.value, rowsdata.moneda),
             valueGetter: (params) => {
               const totalServicio = params.row.total_articulo;
               const valorSinIGV = params.row.include_igv==='EXONERADO' ? 0 :
               params.row.include_igv==='IGV' ? 
               totalServicio - totalServicio / (1.18) : totalServicio - totalServicio / (1.10) ;
               return valorSinIGV;
             },
           },
           { field: 'total_articulo', headerName: 'Total Árticulo', width: 150, align: 'center',headerAlign: 'center',valueFormatter: (params) => formatCurrency(params.value,rowsdata.moneda) },
 
       ];

  const processRowUpdate = useCallback(
    async (newRow) => {
      if (!newRow || typeof newRow !== 'object') {
        setSnackbar({ children: 'Error: newRow no es válido', severity: 'error' });
        return;
      }
  
      const {
        id,
        descripcion,
        Valor_unitario,
        igv,
        precio_unitario,
        fecha_entrega,
        nombre_ceco,
        codigo_departamente,
        codigo_seccion,
        nombre_cuenta,
        codigo_cuenta_contable,nombre_cuenta_contable,
        incluyeIgv
      } = newRow;
  
  
      const updatedRecords = records.map((record) => {
        if (record.id === id) {
          return {
            ...record,
            descripcion,
            Valor_unitario,
            igv,
            precio_unitario,
            fecha_entrega,
            nombre_ceco,
            codigo_departamente,
            codigo_seccion,
            nombre_cuenta,
            codigo_cuenta_contable,nombre_cuenta_contable,incluyeIgv
          };
        }
        return record;
      });
  
      setRecords(updatedRecords);
  
      setSnackbar({ children: 'Guardado exitosamente', severity: 'success' });
  
      const updatedRow = { ...newRow };
      const response = await mutateRow(updatedRow);
      setDataresponse(response);
      setRegistrarbtn(false);
      return response;
    },
    [records, mutateRow]
  );

  useEffect(() => {
    if (dataresponse) {
      const {id,descripcion,Valor_unitario,igv,precio_unitario,fecha_entrega,nombre_ceco,codigo_departamente,codigo_seccion,nombre_cuenta,codigo_cuenta_contable,nombre_cuenta_contable,incluyeIgv} = dataresponse;

       const oldDevices = [...records];
       const rowDeviceIndex = oldDevices.findIndex((dev) => dev.id === id);
       oldDevices[rowDeviceIndex] = {
        ...oldDevices[rowDeviceIndex],
        id,descripcion,Valor_unitario,igv,precio_unitario,fecha_entrega,nombre_ceco,codigo_departamente,codigo_seccion,nombre_cuenta,codigo_cuenta_contable,nombre_cuenta_contable,incluyeIgv
  };
     setRecords(oldDevices);
    }
  }, [dataresponse])

  const calculaTotales = () => {
    let total_pago_vencido = 0;
  
    const totales = records.map((item) => {
      const total_antes_descuento = item.Valor_unitario*1.18;
      total_pago_vencido += total_antes_descuento; // Acumular la suma
  
      return total_pago_vencido;
    });
  
    return {
      totales,
      total_pago_vencido
    };
  };
  const hanbleRegistrar = () => {
  
    if (fechafin.isSameOrBefore(fechainicio)) {
      setSnackbar({ children: 'La fecha inicio del periodo debe menor a la fecha Fin', severity: 'error' });
      return;
    }
    if (periodo==='ninguno') {
      setSnackbar({ children: 'Debe seleccionar un periódo', severity: 'error' });
      return;
    }
    Swal.fire({
      title: 'ACTUALIZACIÓN DE SOLICITUD ORDEN DE SERVICIO'+' '+rowsdata.id_oc_cabecera,
      text: "¿ESTA CONFORME CON LO ACTUALIZADO?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        setCargando(true);
         const datosOrden = {
          id_oc_cabecera: rowsdata.id_oc_cabecera,
           finicio_periodico: moment(fechainicio).format('YYYY-MM-DD'),
  ffin_periodico: moment(fechafin).format('YYYY-MM-DD'),
          periodo:periodo      
         }
         setRegistrarbtn(true);
        OrdenesService.UpdateOCPeriodico(datosOrden,setRegistrarbtn,setSnackbar,user.token).then((res) => { 
         
          });
        // console.log(datosOrden)
      }
    })
  };

  //Nuevo
  const handleComentarioChange = e => {
    const { name, value } = e.target;
    setComment(value)
  }
  const handleObservaciones = e => {
    const { name, value } = e.target;
    setObservaciones(value)
  }
  const handleMotivoTraslado = e => {
    const { name, value } = e.target;
    setMotivotraslado(value)
  }
  const handleContable = (newValue) => {
    setFechacontable(newValue);
  }
  const handleEntrega = (newValue) => {
    setFechaentrega(newValue);
  }
  const handleFechaInicioPeriodo = (newValue) => {
    setFechainicio(newValue);
  }
  const handleFechaFinPeriodo = (newValue) => {
    setFechafin(newValue);
  }
  const handleRegistro = (newValue) => {
    setFecharegistro(newValue);
  }
  const handleSerieDocumento = e => {
    const { name, value } = e.target;
    setSerieDocumento(value)
  }
  const handleCorrelativoDocumento = e => {
    const { name, value } = e.target;
    setCorrelativoDocumento(value)
  }
  const handleChangeTipodeCambio = (event) => {
    setTipocambio(event.target.value);
  };
  const handleAutocompleteChange = (event, value) => {
    setSelectProveedor(value);
    setRuc(value.numero_documento);
    setIdprovedor(value.id_usuario);
    setNombreProvedor(value.razon_social);
    setCodigoProveedorsap(value.id_proveedor_sap);
    setCondicionDepago(value.nombre_condicion_credito);
    setCorreo( value.correo_recepcion!=='' ? value.correo_recepcion : value.correo_logistica !='' ?  value.correo_logistica : value.correo_comercial ? value.correo_comercial  : 'NO HAY CORREO EN SAP');
  };
  const filterOptions = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.razon_social.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.numero_documento.includes(inputValue)
    );
  };
  const handleAutocompletePersonaContacto = (event, value) => {
    setSelectPersonaContacto(value);
    setIdcontacto(value.codigo_empleado_venta);
  };
  const filterOptionsPersonaContacto = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.nombre_empleado_venta.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const handleSelectConditionPago = (event, value) => {
    setSelectedConditionPago(value);
  };
  const filterOptionsDestino = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.nombre_direccion_destino.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  const handleAutocompleteDestino = (event, value) => {
    setSelectedDestino(value);
  };
  
  const sumaTotal = records.reduce(
    (acumulado, datos) => acumulado + datos.Valor_unitario, 
    0
  );
  let igvTotal = 0;
  records.forEach(row => {
    if (row.incluyeIgv) {
      igvTotal += row.Valor_unitario * row.incluyeIgv; 
    }
  });
  
  const totalConIgv = sumaTotal + igvTotal;
  
  const totalCalculado = typeof totalConIgv === 'number'
    ? totalConIgv.toFixed(2)
    : 0;
    const resultadoCalculo = igvTotal.toFixed(2); 





  return (
    <Grid width={'100%'} m="auto">
      <Grid container justifyContent="flex-start" alignItems="center" spacing={2} sx={{ py: 1 }}>
        <Grid container item xs={12} sm={12} >
          <Grid item sm={6} >
            <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>EDITAR ORDEN DE SERVICIO PERIÓDICO # {rowsdata.id_oc_cabecera}</b></CMLabel>
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={12} alignItems="center">
          <Grid item sm={12}>
            <Grid item xs={12} sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Datos del proveedor</b></CMLabel>
            </Grid>
            <Grid container item xs={12} sm={12} alignItems="center">
              <Grid xs={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Proveedor</CMLabel>
              </Grid>
              <Grid xs={12} sm={2}>
               <CMTextField
                  name="ruc"
                  label=''
                  value={rowsdata.nombre_proveedor}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid xs={12} sm={0.5}>
              </Grid>
              <Grid xs={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">RUC</CMLabel>
              </Grid>
              <Grid xs={12} sm={2}>
                <CMTextField
                  name="ruc"
                  label=''
                  value={rowsdata.ruc_proveedor}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid xs={12} sm={0.5}>
              </Grid>
              <Grid xs={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Persona Contacto</CMLabel>
              </Grid>
              <Grid xs={12} sm={2}>
                <CMTextField
                    name="Empleado de venta"
                    label=''
                    value={rowsdata.nombre_empleado_venta}
                    disabled
                    fullWidth
                  />
              </Grid>
            </Grid>
            <Grid container item xs={12} sm={12} sx={{paddingTop:2}} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Condición de pago</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                  name="Condición de pago"
                  label=''
                  value={rowsdata.condic_pago}
                  disabled
                  fullWidth
                />
            </Grid>
            <Grid xs={12} sm={0.5}>
              </Grid> 
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Correo</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                  name="Correo"
                  label=''
                  value={rowsdata.correo_proveedor}
                  disabled
                  fullWidth
                />
            </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12}>
            <Grid item sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Datos de la orden</b></CMLabel>
            </Grid>
            <Grid container item sm={12} alignItems="center">
              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Fecha contable</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <CMDatePicker
                  label="Fecha contable"
                  value={fechacontable}
                  inputFormat="DD/MM/YYYY"
                  onChange={handleContable}
                  maxDate={fechahoy}
                  minDate={moment(fechahoy).subtract(2, 'days')}
                  />
              </Grid>
              <Grid item sx={12} sm={0.5}>
                
              </Grid>
              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Fecha entrega</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <CMDatePicker
                  label="Fecha entrega"
                  value={fechaentrega}
                  inputFormat="DD/MM/YYYY"
                  onChange={handleEntrega}
                  minDate={moment(fechahoy).subtract(2, 'days')}
                  maxDate={fechahoy}

                />
              </Grid>
              <Grid item sx={12} sm={0.5}>

              </Grid>
              <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Tipo de compra</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                name="Tipo de compra"
                label='Tipo de compra'
                value="Compra Local"
                disabled
                fullWidth
              />
            </Grid>
            
            </Grid>
          </Grid>
          <Grid container item sx={{ paddingTop: 3, paddingBottom: 3 }} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Tipo de moneda</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                name="Tipo de moneda"
                label=''
                value={rowsdata.moneda}
                disabled
                fullWidth
              />
            </Grid>
            <Grid item sx={12} sm={0.5}>

            </Grid>
            <Grid item sx={4} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Motivo</CMLabel>
            </Grid>
            <Grid item sx={0.2}>
              <Tooltip title="Motivo control del sistema">
                <InfoIcon sx={{ color: 'primary.main'}}/>
              </Tooltip>
            </Grid>
            <Grid item sx={8} sm={1.8}>
                <CMTextField
                      name="Motivo"
                      label=''
                      value={rowsdata.motivo_solicitud}
                      disabled
                      fullWidth
                      inputProps={{
                        maxLength: 300
                      }}
                    />
            </Grid>
            <Grid item sx={12} sm={0.5}>

            </Grid>

            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Resumen</CMLabel>
            </Grid>
            <Grid item sx={12} sm={0.2}>
              <Tooltip title="Resumen de la orden SAP, en formato Resumen-Tienda">
                <InfoIcon sx={{ color: 'primary.main'}}/>
              </Tooltip>
            </Grid>
            <Grid item sx={12} sm={1.8}>
              <CMTextField
                name="Resumen"
                label=''
                value={rowsdata.observaciones}
                disabled
                fullWidth
                inputProps={{
                  maxLength: 500
                }}
              />
            </Grid>
          </Grid>
          <Grid container item sx={{ paddingTop: 0, paddingBottom: 3 }} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Destino</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
                <CMTextField
                  name="Destino"
                  label=''
                  value={rowsdata.destino}
                  disabled
                  fullWidth
                  inputProps={{
                    maxLength: 500
                  }}
                />
            </Grid>
            <Grid item sx={12} sm={0.5}>
            </Grid>
           
          </Grid>
          <Grid item sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Periodo de creación</b></CMLabel>
            </Grid>

              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Fecha Inicio</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <CMDatePicker
                  label="Fecha Inicio"
                  value={fechainicio}
                  inputFormat="DD/MM/YYYY"
                  onChange={handleFechaInicioPeriodo}
                  minDate={moment(fechahoy).subtract(0, 'days')}
                />
              </Grid>
              <Grid item sx={12} sm={0.5}>
              </Grid>
              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Fecha Fin</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <CMDatePicker
                  label="Fecha Fin"
                  value={fechafin}
                  inputFormat="DD/MM/YYYY"
                  onChange={handleFechaFinPeriodo}
                  minDate={moment(fechahoy).subtract(0, 'days')}

                />
              </Grid>
              <Grid item sx={12} sm={0.5}>
              </Grid>
              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Tipo de Periódo</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <Select
                    labelId="periodo-label"
                    id="periodo-select"
                    value={periodo}
                    onChange={(e) => setPeriodo(e.target.value)} // Asegúrate de definir el estado "periodo"
                    label="Tipo de Período"
                  >
                    <MenuItem value="ninguno">Seleccionar Tipo de Periodo</MenuItem>
                    <MenuItem value="diario">Diario</MenuItem>
                    <MenuItem value="semanal">Semanal</MenuItem>
                    <MenuItem value="quincenal">Quincenal</MenuItem>
                    <MenuItem value="mensual">Mensual</MenuItem>
                    <MenuItem value="semestral">Semestral</MenuItem>
                    <MenuItem value="anual">Anual</MenuItem>
                  </Select>
              </Grid>
          {/* <Grid container item sx={{ paddingTop: 0, paddingBottom: 3 }} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">Tipo Documento</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
                <CMTextField
                      name="Tipo del Documento"
                      label='Tipo del Documento'
                      value={tipoDocumento}
                      disabled
                      fullWidth
                    />
            </Grid>
              <Grid item sx={12} sm={0.5}>

              </Grid>
              <Grid item sx={4} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">Serie Documento</CMLabel>
              </Grid>
              <Grid item sx={8} sm={2}>
                  <CMTextField
                        name="Serie del Documento"
                        label='Serie del Documento'
                        value={serieDocumento}
                        onChange={handleSerieDocumento}
                        fullWidth
                        inputProps={{
                          minLength: 4,
                          maxLength: 4
                        }}
                      />
              </Grid>
              <Grid item sx={12} sm={0.5}>

              </Grid>
              <Grid item sx={4} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">Correlativo Documento</CMLabel>
              </Grid>
              <Grid item sx={8} sm={2}>
                  <CMTextField
                        name="Correlativo del Documento"
                        label='Correlativo del Documento'
                        value={correlativoDocumento}
                        onChange={handleCorrelativoDocumento}
                        fullWidth
                        inputProps={{
                          minLength: 8,
                          maxLength: 8
                        }}
                      />
              </Grid>
          </Grid> */}
          {/* <Grid container item sx={{ paddingTop: 0, paddingBottom: 3 }} alignItems="center">
            <Grid item sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Datos del Servicio</b></CMLabel>
            </Grid>
            <Grid container sm={12} alignItems="center">
                <Grid item sx={12} sm={2} >
                    <CMButton
                    label="Insertar Servicio"
                    variant="contained"
                    onClick={(e) => agregarServicio()}
                  />
                </Grid>
            </Grid>
          </Grid> */}
        </Grid>
        <Grid container item xs={12} sm={12}>
        <Grid style={{ height: 400, width: '100%', overflowX: 'auto' }} sx={{ py: 0 }}>
            {rowsdata.tipo==='Articulo' ?
            <DataGrid
              rows={rowsgrid ? rowsgrid : []}
              columns={columns}
              pageSize={15}
              rowsPerPageOptions={[15]}
                getRowId={(row) => row.id_oc_detalle}

              sx={{
                height: "100%",
                "& .MuiDataGrid-window": {
                  overflowX: 'scroll',
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                },
              }}
              pagination
              rowHeight={50}
              processRowUpdate={processRowUpdate}
              onProcessRowUpdateError={handleProcessRowUpdateError}
              experimentalFeatures={{ newEditingApi: true }}
            />
             :  <DataGrid
             rows={rowsgrid ? rowsgrid : []}
             columns={columns2}
             pageSize={15}
             rowsPerPageOptions={[15]}
               getRowId={(row) => row.id_oc_detalle}

             sx={{
               height: "100%",
               "& .MuiDataGrid-window": {
                 overflowX: 'scroll',
                 "&::-webkit-scrollbar": {
                   width: "0.4em",
                 },
                 "&::-webkit-scrollbar-track": {
                   background: "#f1f1f1",
                 },
                 "&::-webkit-scrollbar-thumb": {
                   backgroundColor: "#888",
                 },
                 "&::-webkit-scrollbar-thumb:hover": {
                   background: "#555",
                 },
               },
             }}
             pagination
             rowHeight={50}
             processRowUpdate={processRowUpdate}
             onProcessRowUpdateError={handleProcessRowUpdateError}
             experimentalFeatures={{ newEditingApi: true }}
           />}
             {!!snackbar && (
                            <Snackbar
                            open
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            onClose={handleCloseSnackbar}
                            autoHideDuration={6000}
                            >
                            <Alert {...snackbar} onClose={handleCloseSnackbar} />
                            </Snackbar>
                        )}
          </Grid>

          <Grid item xs={12} sm={12} container>
            <Grid item xs={12} sm={6} container alignItems="center">
              <Grid item xs={6} sm={3}>
                {/* <CMLabel fontSize='16px' color='black'>Comentario: </CMLabel> */}
              </Grid>
              <Grid item xs={6} sm={6}>
                {/* <CMTextField
                  name="comment"
                  label='Comentario'
                  value={comment}
                  onChange={handleComentarioChange}
                  fullWidth
                /> */}
              </Grid>
            </Grid>
            <Grid item container>
                <Grid item container xs={12} sm={10}>

                </Grid>
                <Grid item container xs={12} sm={2} justifyContent="flex-end">
                  <Grid item xs={6} sm={6}>
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">Subtotal</CMLabel>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                  
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">
                    {rowsdata.moneda==='S/' ? rowsdata.moneda : '$'}{rowsdata.total_antes_descuento} 
                    </CMLabel>

                  </Grid>
                </Grid>
                <Grid item container xs={12} sm={10}>

                </Grid>
                <Grid item container xs={12} sm={2} justifyContent="flex-end">
                  <Grid item xs={6} sm={6}>
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">IGV</CMLabel>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                  
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">
                     {rowsdata.moneda==='S/' ? rowsdata.moneda : '$'}{rowsdata.impuesto} 
                    </CMLabel>

                  </Grid>
                </Grid>
                <Grid item container xs={12} sm={10}>

                </Grid>
                <Grid item container xs={12} sm={2} justifyContent="flex-end">
                  <Grid item xs={6} sm={6}>
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">Total</CMLabel>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                  
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">
                     {rowsdata.moneda==='S/' ? rowsdata.moneda : '$'}{rowsdata.total_pago_vencido} 
                    </CMLabel>

                  </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} container justifyContent="flex-end">
              <CMButton
                label="Actualizar"
                variant="contained"
                sx={{ marginTop: '10px' }}
                onClick={hanbleRegistrar}
                disabled={registrarbtn}
              />
            </Grid>

          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CrearordenPeriodoEditarBorrador